import { MantineThemeOverride } from '@mantine/core'

export const { InputWrapper }: MantineThemeOverride['components'] = {
  InputWrapper: {
    styles: () => ({
      label: {
        fontWeight: 700,
      },
    }),
  },
}
